// import { Content } from './toggle.styled';

export const ExternalLink = (props) => {
  const { title, link, ...rest } = props;

  const click = (event) => {
    event.stopPropagation();
    event.preventDefault();
    // console.log(link);
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <a onClick={click} target="_blank" rel="noopener noreferrer" href={link} {...rest}>
      {title}
    </a>
  );
};
